import REGEX from '../../config/regex';
import jsonPost from '../../util/jsonPost';

export default class Newsletter {
  constructor(context) {
    this.context = context;

    this.emailInput = this.context.querySelector('[data-newsletter="email"]');
    this.fieldset = this.context.querySelector('[data-newsletter-fieldset]');
    this.nameInput = this.context.querySelector('[data-newsletter="name"]');
    this.responseMessage = this.context.querySelector('[data-newsletter-response="message"]');
    this.responseMessageContainer = this.context.querySelector(
      '[data-newsletter-response="container"]'
    );
    this.submitButton = this.context.querySelector('[data-newsletter="submit"]');

    this.apiUrl = this.context.dataset.newsletterUrl;
    this.formId = this.context.dataset.newsletterId;
    this.messageError = this.context.dataset.newsletterError;
    this.messageSuccess = this.context.dataset.newsletterSuccess;
    this.validEmail = false;
    this.validForm = false;
    this.validName = false;

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleValidateEmail = this.handleValidateEmail.bind(this);
    this.handleValidateName = this.handleValidateName.bind(this);
    this.response = this.response.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.init();
  }

  init() {
    if (!this.submitButton || !this.nameInput || !this.emailInput) {
      return;
    }

    this.emailInput.addEventListener('change', this.handleValidateEmail);
    this.nameInput.addEventListener('change', this.handleValidateName);
    this.submitButton.addEventListener('click', this.handleFormSubmit);
  }

  handleFormSubmit() {
    this.submitButton.classList.add('loading');
    this.validateForm();

    if (this.validForm) {
      const name = this.nameInput.value;
      const email = this.emailInput.value;

      const options = {
        name,
        email,
        formId: this.formId,
      };

      jsonPost(this.apiUrl, options, (response) => {
        if (!response) {
          return this.response(this.messageError);
        }

        return this.response(this.messageSuccess);
      });
    }

    this.submitButton.classList.remove('loading');
  }

  response(message) {
    this.responseMessage.innerHTML = `${message}`;
    this.fieldset.classList.add('hidden');
    this.responseMessageContainer.classList.add('visible');
  }

  handleValidateName() {
    const { value } = this.nameInput;
    const isValid = REGEX.name.test(value);

    this.validName = isValid;
    this.nameInput.classList.toggle('invalid', !isValid);
  }

  handleValidateEmail() {
    const { value } = this.emailInput;
    const isValid = REGEX.email.test(value);

    this.validEmail = isValid;
    this.emailInput.classList.toggle('invalid', !isValid);
  }

  validateForm() {
    this.handleValidateName();
    this.handleValidateEmail();

    if (this.validName && this.validEmail) {
      this.nameInput.classList.remove('invalid');
      this.emailInput.classList.remove('invalid');
      this.validForm = true;
      return true;
    }
    return false;
  }
}
